import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ModalWindow from '@kenetto/uikit-modal'

import {currentSelectionActions} from '../../../../../../redux/currentSelection'
import {recommendationsActions} from '../../../../../../redux/recommendations'
import RecommendationBox from './RecommendationBox'
import ImmunizationRecommendation from '../../../../../../models/ImmunizationRecommendion/ImmunizationRecommendation'
import RecommendationEditForm from './RecommendationEditForm'
import { notify } from 'reapop'
import withPolyglot from '../../../../../common/withPolyglot'

class RecommendationBoxContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.renderFormEditModal = this.renderFormEditModal.bind(this)
  }

  handleClick () {
    const { hasSelectedRecommendation, removeSelectedRecommendation, selectRecommendation, recommendation, editMode } = this.props
    if (editMode) {
      this.toggleModal()
    } else {
      if (hasSelectedRecommendation) {
        removeSelectedRecommendation()
      } else {
        selectRecommendation(recommendation.id)
      }
    }
  }

  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  handleRecommendationChangesSubmit (content) {
    const {recommendation, editRecommendation, notify} = this.props
    const recommendationId = recommendation.id
    editRecommendation(recommendationId, content)
    this.toggleModal()
    notify({
      message: this.props.translate('changedRecommendation', true, 'alerts'),
      status: 'success',
      dismissible: true,
      dismissAfter: 5000,
      position: 'bl',
      closeButton: true,
      allowHTML: true,
      buttons: []
    })
  }

  renderFormEditModal () {
    return <ModalWindow
      modalIsOpen={this.state.modalIsOpen}
      toggleModal={this.toggleModal}
      title={this.props.translate('editRecommendationTitle')}>
      <RecommendationEditForm recommendation={this.props.recommendation} translate={this.props.translate} handleSubmit={this.handleRecommendationChangesSubmit.bind(this)} />
    </ModalWindow>
  }

  render () {
    const { recommendation, clickDisabled, editMode } = this.props
    return <Fragment>
      {editMode
        ? this.renderFormEditModal()
        : null
      }
      <RecommendationBox
        editMode={editMode}
        clickDisabled={clickDisabled}
        handleClick={this.handleClick.bind(this)}
        recommendation={recommendation} />
    </Fragment>
  }
}

RecommendationBoxContainer.propTypes = {
  editMode: PropTypes.bool,
  clickDisabled: PropTypes.bool,
  recommendation: PropTypes.instanceOf(ImmunizationRecommendation).isRequired,
  selectRecommendation: PropTypes.func.isRequired,
  removeSelectedRecommendation: PropTypes.func.isRequired,
  editRecommendation: PropTypes.func.isRequired
}

RecommendationBoxContainer.defaultProps = {
  editMode: false,
  clickDisabled: false
}

function mapStateToProps ({currentSelection}) {
  return {
    hasSelectedRecommendation: !!currentSelection.recommendation
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({...currentSelectionActions, ...recommendationsActions, notify}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withPolyglot(RecommendationBoxContainer, 'recommendationEdit'))
